module.exports = __webpack_public_path__ + "static/media/member_trial.f960e4c9.png";